<template>
  <div
    class="rank_division_picker d-flex-column centered"
    :key="type"
    style="height: 100%"
  >
    <div
      class="d-flex-column rainbow-six-siege-boost-champion rank_picker_area"
      style="height: 100%"
    >
      <!-- <p class="t-white">{{ rank }}</p> -->
      <div class="d-flex-row gap-18">
        <img
          :src="rank.image_dark"
          :alt="rank.title + ' - Selected game rank image'"
          class="selected_rank_image"
        />
      </div>

      <div class="d-flex-column gap-0">
        <h4 class="font-family-1 title-h5 f-w-600">{{ title }}</h4>
        <p class="rank-title regular-xl font-family-2 rank_title">
          {{ rank.title }}
        </p>
      </div>

      <div
        class="d-flex-row space-between md-row-to-col"
        style="margin-bottom: 20px"
      >
        <LevelAdjusters
          :title="''"
          :description="$t('select_current_rank')"
          v-model="levelRange.min"
          :min="1"
          :max="9970"
          :defaul-value="1"
          v-if="type === 'currentRank'"
        />
        <LevelAdjusters
          :title="''"
          :description="$t('select_desired_rank')"
          v-model="levelRange.max"
          :min="desiredMin"
          :max="10000"
          :defaul-value="100"
          v-if="type === 'desiredRank'"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import LevelAdjusters from "../../wow/pickers/LevelAdjusters.vue";
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const rank = computed(() => {
  if (gameStore.getGameRanks.length < 0) return null;
  const length = gameStore.getGameRanks.length;

  return gameStore.getGameRanks[length - 1];
});
const props = defineProps({
  type: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
  itemKey: {
    type: String,
    default: "",
  },
  prevRank: {
    default: null,
  },
  showServer: {
    type: Boolean,
    default: false,
  },
  showRpGain: {
    type: Boolean,
    default: false,
  },
});

const steps = ref([
  {
    title: "1",
  },
  {
    title: "10",
  },
  {
    title: "20",
  },
  {
    title: "30",
  },
  {
    title: "40",
  },
  {
    title: "50",
  },
  {
    title: "60",
  },
  {
    title: "70",
  },
  {
    title: "80",
  },
]);

const levelRange = ref({
  min: 1,
  max: 100,
});

watch(
  levelRange,
  (newVal) => {
    if (props.type === "currentRank") {
      console.log(
        levelRange.value.min,
        checkoutStore.getDetails.desiredRankPoints
      );
      if (
        levelRange.value.min <=
        checkoutStore.getDetails.desiredRankPoints - 30
      ) {
        checkoutStore.setDetails({
          ...checkoutStore.getDetails,
          currentRankPoints: levelRange.value.min,
        });
      }

      if (
        checkoutStore.getDetails.desiredRankPoints - 30 <=
        levelRange.value.min
      ) {
        console.log("here");
        checkoutStore.setDetails({
          ...checkoutStore.getDetails,
          currentRankPoints: levelRange.value.min,
          desiredRankPoints: levelRange.value.min + 30,
        });
      }

      if (checkoutStore.getDetails.desiredRankPoints <= levelRange.value.min) {
        checkoutStore.setDetails({
          ...checkoutStore.getDetails,
          desiredRankPoints: levelRange.value.min + 30,
        });
      }
    }
    if (props.type === "desiredRank") {
      const prev = checkoutStore.getDetails.currentRankPoints;
      let difference = levelRange.value.max - prev;
      let lp = difference < 30 ? prev + 30 : levelRange.value.max;
      checkoutStore.setDetails({
        ...checkoutStore.getDetails,
        desiredRankPoints: lp,
      });
    }
  },
  { deep: true }
);

watch(
  () => checkoutStore.getDetails.desiredRankPoints,
  (newVal) => {
    if (newVal > levelRange.value.max) {
      levelRange.value.max = newVal;
    }
  },
  { deep: true }
);
const desiredMin = computed(() => {
  return checkoutStore.getDetails.currentRankPoints + 30;
});
const currentMax = computed(() => {
  return checkoutStore.getDetails.desiredRankPoints - 30;
});
</script>
